import {
    Component, Mixins,
} from 'vue-property-decorator';
import HybridMixin from '@rogues/shared/mixins/hybrid';
import CoreMixin from '@nodes/mixins/Core';
import {
    YSelect, YChips, YRadio, YIcon,
} from '@components/index';
import Props from './props';

@Component({
    components: {
        YSelect,
        YChips,
        YRadio,
        YIcon,
    },
})

/**
 * @name MarketSort
 */
export default class MarketSort extends Mixins(HybridMixin, Props, CoreMixin) {
    showMobileSort = false;

    sortProperties: Array<{[k: string]: string}> = this.getValue('sortBy') || [
        {
            label   : this.$tc('market-sort.newest'),
            value   : undefined,
            checked : !this.$route.query?.sort,
            disabled: false,
            readonly: false,
        },
        {
            label   : this.$tc('market-sort.sale_count'),
            value   : 'sale_count',
            checked : this.$route.query?.sort === 'sale_count',
            disabled: false,
            readonly: false,
        },
        {
            label   : this.$tc('market-sort.rate_average'),
            value   : 'rate_average',
            checked : this.$route.query?.sort === 'rate_average',
            disabled: false,
            readonly: false,
        },
    ];

    orderProperties: Array<{[k: string]: string}> = this.getValue('orderBy') || [
        {
            label   : this.$tc('market-sort.asc'),
            value   : 'asc',
            checked : !this.$route.query.order || this.$route.query.order === 'asc',
            disabled: false,
            readonly: false,
        },
        {
            label   : this.$tc('market-sort.desc'),
            value   : 'desc',
            checked : this.$route.query?.order === 'desc',
            disabled: false,
            readonly: false,
        },
    ];

    /**
     * Return sort router object
     * 
     * @param {object} property - sort property
     * @returns {*}
     */
    sortRouteTo(property: Record<string, any>): any {
        const routeObject = {
            name  : this.$route.name,
            params: this.$route.params,
            query : {
                ...this.$route.query,
                sort: property.value,
            },
        };

        if (property?.changeRoute) {
            return (property.value === undefined && this.$route.query.sort && this.$route.query.order !== undefined)
                ? this.$router.replace(routeObject).catch((err) => {
                    this.handleError(err);
                }) : null;
        }
        return routeObject;
    }

    /**
     * Return order router object
     * 
     * @param {object} property - sort property
     */
    orderRouteTo(property: Record<string, any>) {
        const routeObject = {
            name  : this.$route.name,
            params: this.$route.params,
            query : {
                ...this.$route.query,
                order: property.value,
            },
        };

        if (property.value !== null) {
            this.$router.replace(routeObject).catch((err) => {
                this.handleError(err);
            });
        }
    }

    /**
     * Return sort chips color
     * 
     * @param {object} property - sort property
     * @returns {*}
     */
    chipsColor(property: Record<string, any>): any {
        if (property.value === undefined && !this.$route.query.sort) {
            return 'primary';
        }
        if (this.$route.query.sort === property.value) {
            return 'primary';
        }
        return 'white';
    }

    /**
     * Return monochrome status
     * 
     * @param {object} property - sort property
     * @returns {boolean}
     */
    isMonochrome(property: Record<string, any>): boolean {
        if (property.value === undefined && !this.$route.query.sort) {
            return true;
        }
        if (this.$route.query.sort === property.value) {
            return true;
        }
        return false;
    }

    /**
     * Show mobile sort menu
     */
    sortToggle() {
        this.showMobileSort = !this.showMobileSort;
    }
}
